import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { UserService } from './services/user.service';

export const adminGuard: CanActivateFn = (): Observable<boolean> => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.user$.pipe(
    map(user => {
      if (user.isAdmin) {
        return true;
      } else {
        router.navigate(['/']);
        return false;
      }
    })
  );
};
